export default __webpack_public_path__ + "static/media/PPI-walkway-003.c8e0e4e6.jpg";